import React from 'react';
import { translate } from 'react-i18next';

/**
 * Wraps a child element with a CSS tooltip when the app is offline.
 * Uses ::before/::after pseudo-elements so the tooltip is always positioned
 * relative to the button regardless of the container layout.
 *
 * Subscribes to OfflineStore so it reacts immediately when connectivity
 * changes — callers do not need to subscribe themselves.
 *
 * Usage:
 *   <OfflineTooltip>
 *     <button disabled={!Utils.isOnline()} onClick={...}>Save</button>
 *   </OfflineTooltip>
 */
class OfflineTooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOnline: Utils.isOnline() };
    this._onOnline = () => this.setState({ isOnline: true });
    this._onOffline = () => this.setState({ isOnline: false });
  }

  componentDidMount() {
    OfflineStore.on('app:online', this._onOnline);
    OfflineStore.on('app:offline', this._onOffline);
  }

  componentWillUnmount() {
    OfflineStore.off('app:online', this._onOnline);
    OfflineStore.off('app:offline', this._onOffline);
  }

  render() {
    const { children, t } = this.props;

    if (this.state.isOnline) {
      return children;
    }

    return (
      <span
        className="offline-tooltip"
        data-tooltip={t('offline.unavailable')}
        style={{ display: 'inline-block', cursor: 'not-allowed' }}
      >
        {children}
      </span>
    );
  }
}

export default translate()(OfflineTooltip);
